import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import { highlighterQuickInfoLine } from "helpers/listing-card/quick-info-line";
import { calculatePercentage } from "helpers/calculate-percentage";
import { createHighlighterBadge } from "helpers/create-highlighter-badge";

import HighlighterListingCard from "src/components/homepage/highlighter-card/listing-card";
import HighlighterListingProjectCard from "src/components/homepage/highlighter-card/project-card";
import InfoCard from "src/components/homepage/highlighter-tab-panels/highlighter-info-card";
import SwiperWrapper from "src/components/swiper-wrapper";

import styles from "../styles.module.css";

const ListingWrapper = ({ tabKey, tabTitle, getListings, badgeKey, eventLabel, seeAllListingHref }) => {
  const data = getListings?.listingCard || getListings?.projectCards;
  const isProject = tabKey === "featuredProjectListings";

  return (
    <div>
      <>
        {data?.records?.length === 0 ? (
          <InfoCard />
        ) : (
          <>
            <div className={styles.titleWrapper}>
              <span className={styles.title}>{tabTitle}</span>
              <div className={styles.buttonWrapper}>
                <a href={seeAllListingHref} className={styles.buttonClass}>
                  Tümünü Gör
                </a>
              </div>
            </div>
            <SwiperWrapper>
              <Swiper
                navigation={true}
                loop={data?.records?.length > 4}
                modules={[Navigation]}
                slidesPerView={4}
                preventClicks={false}
                preventClicksPropagation={false}
                allowTouchMove={false}
                simulateTouch={false}
              >
                {data?.records?.map((listingItem, index) => {
                  const quickInfoList = highlighterQuickInfoLine(
                    listingItem?.squareMeter,
                    listingItem?.estateTypeName,
                    listingItem?.quickInfos
                  );

                  const percentageBadge = calculatePercentage(
                    listingItem?.priceDetail?.previousPrice,
                    listingItem?.priceDetail?.price
                  );

                  const category = listingItem?.categoryTypeName;
                  const meterArea = listingItem?.quickInfos?.find((i) => i?.key === "square");
                  const meterPrice = listingItem?.quickInfos?.find((i) => i?.key === "square_meter_price");
                  const trendType = listingItem?.priceDetail?.trendType;
                  const badge = createHighlighterBadge(badgeKey, listingItem?.badges, percentageBadge, trendType);
                  return (
                    <SwiperSlide key={listingItem?.id}>
                      {isProject ? (
                        <HighlighterListingProjectCard listItemInfo={listingItem} index={index} />
                      ) : (
                        <HighlighterListingCard
                          quickInfo={quickInfoList}
                          listItemInfo={listingItem}
                          badges={badge}
                          gtmEventLabel={eventLabel}
                          meterArea={category === "Arsa" && meterArea?.value}
                          meterPrice={category === "Arsa" && meterPrice?.value}
                          index={index}
                        />
                      )}
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </SwiperWrapper>
          </>
        )}
      </>
    </div>
  );
};

ListingWrapper.propTypes = {
  highLighterTabListings: PropTypes.object,
  setHighLighterTabListings: PropTypes.func,
  tabKey: PropTypes.string,
  tabTitle: PropTypes.string,
  getListings: PropTypes.object,
  badgeKey: PropTypes.string,
  eventLabel: PropTypes.string,
  seeAllListingHref: PropTypes.string,
};

export default ListingWrapper;
